// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseLecturerTiles_wrapper__oCwuQ"};